/* istanbul ignore file */
// Please keep in alphabetical order

export function countBy(array, key) {
  return array.reduce((counter, obj) => {
      const counterKey = obj[key];
      if (counter.hasOwnProperty(counterKey)) {
        ++counter[counterKey];
      } else {
        counter[counterKey] = 1;
      }
      return counter;
  }, {});
}

export function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    const later = function() {
      timeout = null;
      func.apply(context, args);
    };
    const callNow = !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {func.apply(context, args);}
  };
}

export function objectIsEmpty(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) { return false; }
    }
    return true;
}

export function once(func) {
  let result;

  let maxCalls = 2;
  return function() {
    if (--maxCalls > 0) {
      result = func.apply(this, arguments);
    }
    if (maxCalls <= 1) {
      func = undefined;
    }
    return result;
  };
}

export function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function() {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function() {
        if ((Date.now() - lastRan) >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

export function toType(obj) {
  return Object.prototype.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
